import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reporting-account-selector"
export default class extends Controller {
  change() {
    let path = window.location.pathname
    let new_path = path.replace(/account\/\d+/, "account/" + this.element.value)
    Turbo.visit(new_path);
  }
}
